import * as React from "react";

const PlankMobile: React.FC = () => {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.75 28.7227L27.4167 12.75L49.5 15.4688M9.75 28.7227L40.6667 37.5586M9.75 28.7227L11.109 34.8398L40.6667 45.375M40.6667 37.5586L49.5 15.4688M40.6667 37.5586V45.375M49.5 15.4688L48.8205 20.9062L40.6667 45.375" stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
    );
};

export default React.memo(PlankMobile);
